module.exports = __webpack_public_path__ + "media/images/icons/pix-logo-black-3066d6f9262a1498411bbd0e4ec75cf0.svg";